import { Component, OnInit } from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
  loading = false;
  currentYear = new Date().getFullYear();

  formData: {
    email: string;
  } = {
    email: null,
  };

  constructor(
    private toastr: NbToastrService,
    private router: Router,
    private auth: AngularFireAuth,
  ) {}

  ngOnInit() {}

  async onSubmit(form: NgForm) {
    if (form.invalid) {
      return;
    }

    this.loading = true;
    try {
      await this.auth.sendPasswordResetEmail(this.formData.email);
      this.toastr.info('Successfully sent. Check your inbox');
      this.router.navigate(['/auth/login']);
    } catch (error) {
      this.toastr.warning(error.message || error, 'Oops ...');
      console.error(error);
    }
    this.loading = false;
  }
}
